// extracted by mini-css-extract-plugin
module.exports = {"root":"LoginForm_root__2nQZh","loginForm":"LoginForm_loginForm__2zHjR","companyName":"LoginForm_companyName__3WtII"};